import React, { useState } from "react";
import { Grid } from "@mui/material";
import styles from "./intro_video.module.scss";
import { getAssets } from "@unisearch/helpers";
import dynamic from "next/dynamic";
const ModalVideo = dynamic(() => import("react-modal-video"), { ssr: false });
import PlayButtonWithRipple from "@modules/study/common/play_btn_with_ripple";

export const VOfficeIntroVideo = () => {
  const [isOpen, setOpen] = useState(false);
  return (
    <section className={styles.section_intro_video}>
      <div className="container">
        <Grid container spacing={{ xs: 2, sm: 2, md: 4 }}>
          <Grid item xs={12} sm={6} md={6}>
            <div className={styles.title_wrapper}>
              <h2>Welcome to UniSearch Virtual Office!</h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac
                massa enim id tincidunt eget vitae. Consequat egestas amet, elit
                eu. Egestas placerat laoreet varius risus, mauris vitae dui,
                amet. Nulla quam porttitor non consequat, pulvinar. Eu odio nam
                convallis velit enim volutpat.
              </p>
              <p>
                Ipsum quis pulvinar vitae bibendum gravida maecenas fusce etiam.
                Scelerisque sit nunc, praesent blandit risus. Tortor vulputate
                nibh ipsum amet, nam turpis volutpat facilisis ornare. Orci.
              </p>
            </div>
            <a
              href="#form"
              className={`${styles.btn_wrapper} btn btn-secondary btn-bg`}
            >
              Register Now
            </a>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets(
                  "assets/images/voffice/intro_video_bg_image.png"
                )}
                alt="Intro video image"
              />
              <PlayButtonWithRipple colorOrange onClick={() => setOpen(true)} />
            </div>

            <ModalVideo
              channel="custom"
              autoplay
              isOpen={isOpen}
              url="https://d2ogu7kfbtzzv3.cloudfront.net/files/UniSearch_Finale-1634995602483.mp4"
              onClose={() => setOpen(false)}
            />
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default VOfficeIntroVideo;
